import { Constants } from '@/data/constants';
import { Holiday, timewalkingHolidays } from '@/enums/holiday';
import { DbResetType } from '@/shared/stores/db/enums';
import type { Task } from '@/types/tasks';

export const eventTimewalking: Task = {
    key: 'eventTimewalking',
    name: '[Event] Timewalking',
    shortName: 'TW',
    minimumLevel: 10,
    showSeparate: true,
    chores: [
        {
            key: 'dungeons',
            name: 'Dungeons',
            icon: ':time::dungeon:',
            minimumLevel: 10,
            requiredHolidays: timewalkingHolidays,
            questReset: DbResetType.Weekly,
            questIds: (char) => {
                if (char.level < Constants.characterMaxLevel) {
                    return [
                        85947, // An Original Journey Through Time [Classic not max]
                        85948, // A Burning Journey Through Time [TBC not max]
                        85949, // A Frozen Journey Through Time [Wrath not max]
                        86556, // A Shattered Journey Through Time [Cata not max]
                        86560, // A Shrouded Journey Through Time [MoP not max]
                        86563, // A Savage Journey Through Time [WoD not max]
                        86564, // A Fel Journey Through Time [Legion not max]
                        88808, // A Scarred Journey Through Time [BfA not max]
                        92647, // A Shadowed Journey Through Time [SL not max]
                        93495, // A Soaring Journey Through Time [DF not max]
                    ];
                } else {
                    return [
                        93607, // An Original Path Through Time [Classic max]
                        93608, // A Burning Path Through Time [TBC max]
                        93610, // A Frozen Path Through Time [Wrath max]
                        93611, // A Shattered Path Through Time [Cata max]
                        93612, // A Shrouded Path Through Time [MoP max]
                        93613, // A Savage Path Through Time [WoD max]
                        93614, // A Fel Path Through Time [Legion max]
                        93627, // A Scarred Path Through Time [BfA max]
                        92649, // A Shadowed Path Through Time [SL max]
                        93628, // A Shadowed Path Through Time [SL max]
                        93497, // A Soaring Path Through Time [DF max]
                    ];
                }
            },
        },
        {
            key: 'dungeonItem',
            name: 'Dungeon Item',
            icon: ':time::item:',
            requiredHolidays: timewalkingHolidays,
            questReset: DbResetType.Weekly,
            questIds: [
                83285, // Classic
                40168, // TBC
                40173, // WotLK
                40787, // Cata [A]
                40786, // Cata [H]
                45563, // MoP
                55498, // WoD [A]
                55499, // WoD [H]
                64710, // Legion
                89222, // BfA [A]
                89223, // BfA [H]
                92650, // SL
                93852, // DF
            ],
        },
        {
            key: 'raid',
            name: 'Raid',
            minimumLevel: 30,
            requiredHolidays: [
                Holiday.TimewalkingTbc,
                Holiday.TimewalkingWotlk,
                Holiday.TimewalkingCata,
            ],
            questIds: [
                47523, // TBC [Black Temple]
                50316, // WotLK [Ulduar]
                57637, // Cata [Firelands]
            ],
            questReset: DbResetType.Weekly,
        },
    ],
};
